

// import { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import { io } from "socket.io-client";
// import ApiCallService from "../Service/ApiCallService.jsx";

// const API_URL = process.env.REACT_APP_BASE_URL;
// export function useNotifications(token) {
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [loading, setLoading] = useState(Boolean(token));
//   const [error, setError] = useState("");

//   const socketRef = useRef(null);

//   // ---------------------------------------------------------
//   // Mark single notification as read
//   // ---------------------------------------------------------
//   const markNotificationRead = useCallback(
//     async (notificationId) => {
//       if (!notificationId || !token) return;

//       try {
//         await ApiCallService.patch(
//           `${API_URL}/${notificationId}/read`
//         );

//         setNotifications((prev) =>
//           prev.map((notification) => {
//             if (String(notification._id || notification.id) !== String(notificationId)) {
//               return notification;
//             }

//             if (notification.isRead === false || notification.isRead === undefined) {
//               setUnreadCount((count) => Math.max(0, count - 1));
//             }
//             return { ...notification, isRead: true };
//           })
//         );
//         window.dispatchEvent(new CustomEvent("bjs:notification:read", {
//           detail: { id: notificationId },
//         }));
//       } catch (err) {
//         console.error(
//           "Failed to mark notification as read:",
//           err
//         );
//       }
//     },
//     [token]
//   );

//   // ---------------------------------------------------------
//   // Mark all notifications as read
//   // ---------------------------------------------------------
//   const markAllNotificationsRead = useCallback(async () => {
//     if (!token) return;

//     try {
//       await ApiCallService.patch(`${API_URL}/read-all`);

//       setNotifications((prev) =>
//         prev.map((notification) => ({
//           ...notification,
//           isRead: true,
//         }))
//       );

//       setUnreadCount(0);
//       window.dispatchEvent(new CustomEvent("bjs:notification:read-all"));
//     } catch (err) {
//       console.error(
//         "Failed to mark all notifications as read:",
//         err
//       );

//       setError(
//         err.response?.data?.error ||
//           "Failed to mark all notifications as read"
//       );
//     }
//   }, [token]);

//   // ---------------------------------------------------------
//   // Fetch notifications
//   // ---------------------------------------------------------
//   const fetchNotifications = useCallback(async () => {
//     if (!token) {
//       setNotifications([]);
//       setUnreadCount(0);
//       setLoading(false);
//       setError("");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");


//       const response = await ApiCallService.get(
//         `${API_URL}/notifications`,
//         {
//           params: {
//             page: 1,
//             limit: 20,
//           },
//         }
//       );
//       const result = response || {};
//       const nextNotifications = Array.isArray(result.data)
//         ? result.data
//         : Array.isArray(result.notifications)
//           ? result.notifications
//           : [];

//       setNotifications(nextNotifications);
//       setUnreadCount(Number(result.unreadCount || 0));
//     } catch (err) {
//       console.error(
//         "NOTIFICATION API: Error fetching notifications:",
//         err
//       );

//       setError(
//         err.response?.data?.error ||
//           "Failed to fetch notifications"
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   // ---------------------------------------------------------
//   // Socket.IO
//   // ---------------------------------------------------------
//   useEffect(() => {
//     if (!token) {
     

//       setNotifications([]);
//       setUnreadCount(0);
//       setLoading(false);
//       setError("");

//       if (socketRef.current) {
//         socketRef.current.disconnect();
//         socketRef.current = null;
//       }

//       return;
//     }

//     let isMounted = true;

//     const initializeSocket = async () => {
//       // -----------------------------------------------------
//       // First load existing notifications
//       // -----------------------------------------------------
//       await fetchNotifications();

//       if (!isMounted) return;

//       // -----------------------------------------------------
//       // Close previous socket
//       // -----------------------------------------------------
//       if (socketRef.current) {
      

//         socketRef.current.disconnect();
//         socketRef.current = null;
//       }

      
// const socket = io(API_URL.replace(/\/api\/?$/, ""), {
//   auth: { token },
//   transports: ["websocket", "polling"],
//   reconnection: true,
//   reconnectionAttempts: Infinity,
//   reconnectionDelay: 1000,
// });


// socket.on("connect", () => {
//   console.log("STEP 7: 🔥 Socket.IO CONNECTED");
// });

// socket.on("connect_error", (err) => {
//   console.error("STEP 7: ❌ Socket connection error:", err.message);
// });


//       socketRef.current = socket;

//       // -----------------------------------------------------
//       // Socket connected
//       // -----------------------------------------------------
//       socket.on("connect", () => {
      
//       });

//       // -----------------------------------------------------
//       // Connection error
//       // -----------------------------------------------------
//       socket.on("connect_error", (err) => {
//         console.error(
//           "STEP 7: ❌ Socket.IO connection error:",
//           err.message || err
//         );
//       });

//       // -----------------------------------------------------
//       // Disconnect
//       // -----------------------------------------------------
//       socket.on("disconnect", (reason) => {
//       });

//       // -----------------------------------------------------
//       // New notification
//       // -----------------------------------------------------
//       socket.on(
//         "notification:new",
//         (notification) => {
        

//           if (!notification || !notification._id) {
          

//             return;
//           }

//           let wasAdded = false;
//           setNotifications((prev) => {
//             // Prevent duplicate notification
//             const alreadyExists = prev.some(
//               (item) =>
//                 String(item._id || item.id) ===
//                 String(notification._id)
//             );

//             if (alreadyExists) {
            
//               return prev;
//             }

          

//             wasAdded = true;
//             return [
//               notification,
//               ...prev,
//             ];
//           });

//           if (wasAdded && notification.isRead !== true) {
//             setUnreadCount((prev) => prev + 1);
//           }
//           window.dispatchEvent(new CustomEvent("bjs:notification:new", {
//             detail: notification,
//           }));
//         }
//       );

//       // -----------------------------------------------------
//       // Notification updated
//       // -----------------------------------------------------
//       socket.on(
//         "notification:updated",
//         (update) => {


//           if (!update || !update.id) {
//             return;
//           }

//           setNotifications((prev) =>
//             prev.map((notification) =>
//               String(
//                 notification._id ||
//                   notification.id
//               ) === String(update.id)
//                 ? {
//                     ...notification,
//                     ...update,
//                     isRead: Boolean(
//                       update.isRead
//                     ),
//                   }
//                 : notification
//             )
//           );

//           if (update.isRead) {
//             setNotifications((prev) => {
//               const previousNotification = prev.find(
//                 (notification) => String(notification._id || notification.id) === String(update.id)
//               );
//               if (previousNotification && previousNotification.isRead !== true) {
//                 setUnreadCount((count) => Math.max(0, count - 1));
//               }
//               return prev;
//             });
//           }
//           window.dispatchEvent(new CustomEvent("bjs:notification:updated", {
//             detail: update,
//           }));
//         }
//       );
//     };

//     initializeSocket();

//     // -------------------------------------------------------
//     // Cleanup
//     // -------------------------------------------------------
//     return () => {
//       isMounted = false;

    

//       if (socketRef.current) {
//         socketRef.current.disconnect();
//         socketRef.current = null;
//       }
//     };
//   }, [token, fetchNotifications]);

//   useEffect(() => {
//     const handlePageRead = (event) => {
//       const notificationId = event.detail?.id;
//       if (!notificationId || event.detail?.source !== "page") return;
//       setNotifications((prev) =>
//         prev.map((notification) =>
//           String(notification._id || notification.id) === String(notificationId)
//             ? { ...notification, isRead: true }
//             : notification
//         )
//       );
//     };
//     const handlePageReadAll = (event) => {
//       if (event.detail?.source !== "page") return;
//       setNotifications((prev) => prev.map((notification) => ({ ...notification, isRead: true })));
//       setUnreadCount(0);
//     };

//     window.addEventListener("bjs:notification:read", handlePageRead);
//     window.addEventListener("bjs:notification:read-all", handlePageReadAll);
//     return () => {
//       window.removeEventListener("bjs:notification:read", handlePageRead);
//       window.removeEventListener("bjs:notification:read-all", handlePageReadAll);
//     };
//   }, []);

//   // ---------------------------------------------------------
//   // Notification state
//   // ---------------------------------------------------------
//   const notificationState = useMemo(
//     () => ({
//       notifications,
//       unreadCount,
//       loading,
//       error,
//       setNotifications,
//       setUnreadCount,
//       fetchNotifications,
//       markNotificationRead,
//       markAllNotificationsRead,
//     }),
//     [
//       notifications,
//       unreadCount,
//       loading,
//       error,
//       fetchNotifications,
//       markNotificationRead,
//       markAllNotificationsRead,
//     ]
//   );

//   return notificationState;
// }

// export default useNotifications;
















import {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import { io } from "socket.io-client";

import ApiCallService from "../Service/ApiCallService.jsx";

const API_URL =
  process.env.REACT_APP_BASE_URL;

const SOCKET_URL =
  API_URL?.replace(/\/api\/?$/, "");

export function useNotifications(token) {

  const [
    notifications,
    setNotifications,
  ] = useState([]);

  const [
    unreadCount,
    setUnreadCount,
  ] = useState(0);

  const [
    loading,
    setLoading,
  ] = useState(Boolean(token));

  const [
    error,
    setError,
  ] = useState("");

  const socketRef =
    useRef(null);

  // =========================================================
  // FETCH NOTIFICATIONS
  // =========================================================

  const fetchNotifications =
    useCallback(async () => {

      if (!token) {

        setNotifications([]);
        setUnreadCount(0);
        setLoading(false);
        setError("");

        return;
      }

      try {

        setLoading(true);
        setError("");

        const response =
          await ApiCallService.get(
            `${API_URL}/notifications`,
            {
              params: {
                page: 1,
                limit: 20,
              },
            }
          );

        const result =
          response || {};

        const nextNotifications =
          Array.isArray(result.data)
            ? result.data
            : Array.isArray(
                result.notifications
              )
              ? result.notifications
              : [];

        setNotifications(
          nextNotifications
        );

        setUnreadCount(
          Number(
            result.unreadCount || 0
          )
        );

      } catch (err) {

        console.error(
          "Failed to fetch notifications:",
          err
        );

        setError(
          err?.response?.data?.error ||
          "Failed to fetch notifications"
        );

      } finally {

        setLoading(false);
      }

    }, [token]);

  // =========================================================
  // MARK ONE AS READ
  // =========================================================

  const markNotificationRead =
    useCallback(
      async (notificationId) => {

        if (
          !notificationId ||
          !token
        ) {
          return;
        }

        try {

          await ApiCallService.patch(
            `${API_URL}/${notificationId}/read`
          );

          setNotifications(
            (previous) =>
              previous.map(
                (notification) => {

                  const id =
                    notification._id ||
                    notification.id;

                  if (
                    String(id) !==
                    String(notificationId)
                  ) {
                    return notification;
                  }

                  if (
                    notification.isRead !==
                    true
                  ) {

                    setUnreadCount(
                      (count) =>
                        Math.max(
                          0,
                          count - 1
                        )
                    );
                  }

                  return {
                    ...notification,
                    isRead: true,
                  };
                }
              )
          );

        } catch (error) {

          console.error(
            "Failed to mark notification as read:",
            error
          );
        }

      },
      [token]
    );

  // =========================================================
  // MARK ALL AS READ
  // =========================================================

  const markAllNotificationsRead =
    useCallback(async () => {

      if (!token) {
        return;
      }

      try {

        await ApiCallService.patch(
          `${API_URL}/read-all`
        );

        setNotifications(
          (previous) =>
            previous.map(
              (notification) => ({
                ...notification,
                isRead: true,
              })
            )
        );

        setUnreadCount(0);

      } catch (error) {

        console.error(
          "Failed to mark all notifications as read:",
          error
        );

        setError(
          error?.response?.data?.error ||
          "Failed to mark all notifications as read"
        );
      }

    }, [token]);

  // =========================================================
  // SOCKET.IO
  // =========================================================

  useEffect(() => {

    if (!token) {

      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }

      setNotifications([]);
      setUnreadCount(0);
      setLoading(false);

      return;
    }

    let mounted = true;

    // -------------------------------------------------------
    // Initial API load
    // -------------------------------------------------------

    fetchNotifications();

    // -------------------------------------------------------
    // Close previous socket
    // -------------------------------------------------------

    if (socketRef.current) {

      socketRef.current.disconnect();

      socketRef.current = null;
    }

    // -------------------------------------------------------
    // Create socket
    // -------------------------------------------------------

    const socket =
      io(SOCKET_URL, {

        auth: {
          token,
        },

        transports: [
          "websocket",
          "polling",
        ],

        reconnection: true,

        reconnectionAttempts:
          Infinity,

        reconnectionDelay: 1000,

        reconnectionDelayMax:
          5000,
      });

    socketRef.current =
      socket;

    // =======================================================
    // CONNECT
    // =======================================================

    socket.on(
      "connect",
      () => {

        console.log(
          "================================"
        );

        console.log(
          "SOCKET CONNECTED"
        );

        console.log(
          "Socket ID:",
          socket.id
        );

        console.log(
          "================================"
        );
      }
    );

    // =======================================================
    // CONNECT ERROR
    // =======================================================

    socket.on(
      "connect_error",
      (error) => {

        console.error(
          "Socket connection error:",
          error.message
        );
      }
    );

    // =======================================================
    // NEW NOTIFICATION
    // =======================================================

    // socket.on(
    //   "notification:new",
    //   (notification) => {

    //     if (
    //       !mounted ||
    //       !notification ||
    //       !notification._id
    //     ) {
    //       return;
    //     }

    //     console.log(
    //       "NEW NOTIFICATION RECEIVED:",
    //       notification
    //     );

    //     setNotifications(
    //       (previous) => {

    //         const alreadyExists =
    //           previous.some(
    //             (item) =>
    //               String(
    //                 item._id ||
    //                 item.id
    //               ) ===
    //               String(
    //                 notification._id
    //               )
    //           );

    //         if (
    //           alreadyExists
    //         ) {
    //           return previous;
    //         }

    //         return [
    //           notification,
    //           ...previous,
    //         ];
    //       }
    //     );

    //     // Increase unread count
    //     if (
    //       notification.isRead !==
    //       true
    //     ) {

    //       setUnreadCount(
    //         (count) =>
    //           count + 1
    //       );
    //     }

    //     // Optional global event
    //     window.dispatchEvent(
    //       new CustomEvent(
    //         "bjs:notification:new",
    //         {
    //           detail:
    //             notification,
    //         }
    //       )
    //     );
    //   }
    // );





socket.on("notification:new", (notification) => {



  console.log("new notifications receivedddd ", notification )
  if (
    !mounted ||
    !notification ||
    !notification._id
  ) {
    return;
  }

  console.log(
    "🔔 NEW NOTIFICATION RECEIVED:",
    notification
  );

  let isNewNotification = false;

  setNotifications((previous) => {

    const alreadyExists = previous.some(
      (item) =>
        String(item._id || item.id) ===
        String(notification._id)
    );

    if (alreadyExists) {
      console.log(
        "Duplicate frontend notification ignored:",
        notification._id
      );

      return previous;
    }

    isNewNotification = true;

    return [
      notification,
      ...previous,
    ];
  });

  if (
    isNewNotification &&
    notification.isRead !== true
  ) {
    setUnreadCount(
      (count) => count + 1
    );
  }

  window.dispatchEvent(
    new CustomEvent(
      "bjs:notification:new",
      {
        detail: notification,
      }
    )
  );
});









    // =======================================================
    // DISCONNECT
    // =======================================================

    socket.on(
      "disconnect",
      (reason) => {

        console.log(
          "Socket disconnected:",
          reason
        );
      }
    );

    // =======================================================
    // CLEANUP
    // =======================================================

    return () => {

      mounted = false;

      socket.off(
        "notification:new"
      );

      socket.off(
        "connect"
      );

      socket.off(
        "connect_error"
      );

      socket.off(
        "disconnect"
      );

      socket.disconnect();

      if (
        socketRef.current ===
        socket
      ) {
        socketRef.current =
          null;
      }
    };

  }, [
    token,
    fetchNotifications,
  ]);

  // =========================================================
  // RETURN
  // =========================================================

  return {
    notifications,
    unreadCount,
    loading,
    error,

    setNotifications,
    setUnreadCount,

    fetchNotifications,

    markNotificationRead,

    markAllNotificationsRead,
  };
}

export default useNotifications;